export type ProjectPlanOption = {
    Id: string;
    Name: string;
    CreatedAt?: string; // optional for sorting
};

export class ProjectPlanPickerDialogViewModel
{
    opened: boolean = false;
    initialized: boolean = false;

    // context
    projectId: string | null = null;
    projectName: string | null = null;

    // data
    plans: ProjectPlanOption[] = [];
    activePlanId: string | null = null;

    // lock
    lockedPlanId: string | null = null; // null = follow Active (default), otherwise locked to plan

    // -------- convenience ----------
    get hasActive(): boolean { return !!this.activePlanId; }
    get canConfirm(): boolean { return this.initialized; }
    get isLocked(): boolean { return this.lockedPlanId !== null; }

    // -------- lifecycle ----------
    show(
        projectId: string,
        projectName: string,
        activePlanId: string | null,
        lockedPlanId: string | null // null → follow Active (default), otherwise lock
    )
    {
        this.initialized = false;

        this.projectId = projectId;
        this.projectName = projectName;
        this.plans = [];
        this.activePlanId = activePlanId;
        this.lockedPlanId = lockedPlanId;

        this.opened = true;
    }

    setData(plans: ProjectPlanOption[])
    {
        this.plans = new Array(...plans);

        // if locked plan not in list → clear lock
        if (this.lockedPlanId && !plans.some(p => p.Id === this.lockedPlanId))
        {
            this.lockedPlanId = null;
        }

        this.initialized = true;
    }

    resetToDefault()
    {
        this.lockedPlanId = null; // back to follow Active
    }

    lockToPlan(planId: string)
    {
        this.lockedPlanId = planId;
    }

    close()
    {
        this.opened = false;
        this.initialized = false;

        this.projectId = null;
        this.projectName = null;        
        this.activePlanId = null;
        this.lockedPlanId = null;

        this.plans = [];
    }
}
